<script setup lang="ts">
import SmartFormFields from '@app/components/forms/smartFormFields.vue';
import Button from '@ui/components/forms/button.vue';
import { ref } from 'vue';

import { useLogin } from '@app/components/login/useLogin';
const { form, sso, buttons, workspace, onButton, onFormField, onSubmit, onFormCallback } = useLogin();
const loginForm = ref(null);
onFormCallback(async (callback) => {
    if (callback.action === 'validate' && loginForm.value) {
        loginForm.value.validateAllFields();
    }
});
</script>
<template>
    <form
        v-if="form.fields?.length > 0 || buttons?.length > 0"
        class=" space-y-4"
        :class="[sso?.length > 0 ? '' : 'mb-8', workspace ? '' : 'mt-6'].join(' ')"
        @submit.prevent="onSubmit"
    >
        <SmartFormFields
            v-if="form?.fields?.length > 0"
            ref="loginForm"
            :fields="form.fields"
            :show-errors="form?.showErrors"
            :validate-on-load="form?.validateOnLoad"
            :validation-messages="form?.validationMessages"
            allow-changes
            controlled
            class="space-y-4"
            @update:fields="(value) => onFormField(value)"
        ></SmartFormFields>
        <div
            v-if="buttons && buttons?.length > 0"
            class="flex flex-wrap justify-between gap-4"
        >
            <Button
                v-for="button in buttons"
                :key="button.name"
                :name="button.name"
                :theme="button?.theme"
                :type="button?.type"
                :size="button?.size"
                :class="button?.class"
                :icon="button?.icon"
                :disabled="form.loading"
                @click="onButton(button)"
            >
                {{ button.title }}
            </Button>
        </div>
    </form>
</template>
